<div class="p-8">
  <div class="flex justify-between items-center mb-6">
    <h1 class="text-3xl font-bold text-gray-900">Redirects</h1>
    <button (click)="addRow()" [disabled]="saving"
      class="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 disabled:bg-gray-300">
      + Add Redirect
    </button>
  </div>

  <div class="bg-white rounded-lg shadow">
    <div class="grid grid-cols-[1fr_1fr_auto] items-center px-4 py-2 border-b text-xs font-medium uppercase text-gray-500">
      <div>From</div>
      <div>To</div>
      <div class="w-32 text-right">Actions</div>
    </div>

    <div *ngIf="rows.length === 0" class="p-8 text-center text-gray-400">
      No redirects yet. Click "Add Redirect" to get started.
    </div>

    <div *ngFor="let row of rows; let i = index"
      class="grid grid-cols-[1fr_1fr_auto] items-start gap-3 px-4 py-3 border-b group hover:bg-gray-50">

      <ng-container *ngIf="!row.editing">
        <div class="text-sm text-gray-900 break-all py-1">{{ row.from }}</div>
        <div class="text-sm text-gray-900 break-all py-1">{{ row.to }}</div>
        <div class="w-32 flex items-center justify-end space-x-1 opacity-0 group-hover:opacity-100 transition-opacity">
          <button (click)="edit(i)" title="Edit" class="p-1 text-gray-400 hover:text-blue-600 rounded">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
            </svg>
          </button>
          <button (click)="askDelete(i)" title="Delete" class="p-1 text-gray-400 hover:text-red-600 rounded">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
            </svg>
          </button>
        </div>
      </ng-container>

      <ng-container *ngIf="row.editing">
        <div>
          <input type="text" [(ngModel)]="row.draft.from" placeholder="/old-page"
            class="w-full border rounded px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            [class.border-red-400]="row.errors.from">
          <p *ngIf="row.errors.from" class="mt-1 text-xs text-red-600">{{ row.errors.from }}</p>
        </div>
        <div>
          <input type="text" [(ngModel)]="row.draft.to" placeholder="/new-page or https://example.com/page"
            class="w-full border rounded px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            [class.border-red-400]="row.errors.to">
          <p *ngIf="row.errors.to" class="mt-1 text-xs text-red-600">{{ row.errors.to }}</p>
        </div>
        <div class="w-32 flex items-center justify-end space-x-1">
          <button (click)="save(i)" [disabled]="saving"
            class="px-2.5 py-1 text-xs text-white bg-blue-600 rounded hover:bg-blue-700 disabled:bg-gray-300">
            Save
          </button>
          <button (click)="cancel(i)" [disabled]="saving"
            class="px-2.5 py-1 text-xs text-gray-700 bg-gray-100 rounded hover:bg-gray-200">
            Cancel
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<app-confirmation-modal
  [show]="showDeleteModal"
  title="Delete Redirect"
  message="Are you sure you want to delete this redirect?"
  confirmText="Delete"
  (confirm)="confirmDelete()"
  (cancel)="cancelDelete()">
</app-confirmation-modal>
